// extracted by mini-css-extract-plugin
export var footer = "default-module--footer--554e8";
export var inner = "default-module--inner--d2dd2";
export var pageWrapper = "default-module--pageWrapper--99825";
export var socialIcon = "default-module--social-icon--bf151";